export const COURSE_PROGRESS_STATUSES = Object.freeze({
  IN_PROGRESS: "IN PROGRESS",
  WATCHED: "WATCHED",
})
